<template lang="pug" src="./custom-invisalign-advantage.pug"></template>

<script>
import Accordion from '../../accordion/accordion'
import SliderInvisalign from '../../slider/invisalign/slider-invisalign'

export default {
  props: ['content'],
  components: {
    Accordion,
    SliderInvisalign
  }
}
</script>



// WEBPACK FOOTER //
// custom-invisalign-advantage.vue?68a1619e